<template>
  <div class="PersonCenter">
    <div class="title">
      <span>个人中心</span>
    </div>

    <div class="person_center_info">
      <div class="info_wrapper">
        <div class="info_top">
          <div class="l">
            <!-- <el-badge :value="99">
            </el-badge> -->
            <img :src="imgUrl.userDefaultAvatar" alt="">
          </div>
          <span class="ellipsis-1" style="color: #1D2129;">学员姓名</span>
        </div>

        <div class="line"></div>

        <div class="info_bottom">
          <div class="info_bottom_item">
            <img src="https://cdnws.51tyty.com/lstyty/file/2024/09/02/c25e138aa46eb95b9da5edd1989af0a9.png" alt="">
            <p>9999</p>
          </div>
          <div class="info_bottom_item">
            <img src="https://cdnws.51tyty.com/lstyty/file/2024/09/02/7e00b1f9bc306055120f2742b60bd2ce.png" alt="">
            <p>9999</p>
          </div>
          <div class="info_bottom_item">
            <img src="https://cdnws.51tyty.com/lstyty/file/2024/09/02/3b9e42419f7a70010aad87f745d80ad5.png" alt="">
            <p>99999</p>
          </div>
        </div>
      </div>
    </div>

    <div class="person_center_func">
      <div class="item">
        <img src="https://cdnws.51tyty.com/lstyty/file/2024/09/02/fc107f0363b285a60e39629c2b24bf13.png" alt="">
        <span class="label">消息</span>
        <!-- <span class="dot"></span> -->
      </div>
      <div class="item">
        <img src="https://cdnws.51tyty.com/lstyty/file/2024/09/02/58cc222db91a6aff0d307e21ddc4536d.png" alt="">
        <span class="label">动态</span>
        <!-- <span class="dot"></span> -->
        <img class="tag" src="https://cdnws.51tyty.com/lstyty/file/2024/12/17/2b089d425c5f37817d3c6f1f84149844.png" />
      </div>
      <div class="item">
        <img src="https://cdnws.51tyty.com/lstyty/file/2024/09/02/d3d87bf29fc201fa78e483bb793f2933.png" alt="">
        <span class="label">设置</span>
        <!-- <span class="dot"></span> -->
      </div>
      <div class="item">
        <img src="https://cdnws.51tyty.com/lstyty/file/2024/09/02/b89f5989b8921bbbe4f027c3f12b6410.png" alt="">
        <span class="label">家长通</span>
        <!-- <span class="dot"></span> -->
      </div>
    </div>
  </div>
</template>

<script>
import imgUrl from '@/config/imageURL'
export default {
  name: 'PersonCenter',

  props:{
    personalCenter:{
      type:Object,
      default:() => {}
    }
  },

  data() {
    return {
      imgUrl
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="less" scoped>
.PersonCenter{
  width: 190px;
  border-radius: 10px;
  height: 267px;
  position: relative;
  background: linear-gradient( 180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.3) 100%);
  box-shadow: inset 0px 0px 7px 2px rgba(255, 255, 255, 0.6);
  .title{
    width: calc(238px / 2);
    height: calc(43px / 2);
    text-align: center;
    display: inline-block;
    position: relative;
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    background: url("https://cdnws.51tyty.com/lstyty/file/2024/09/02/a96b7e991d8909c578c8476d7fb3d1aa.png");
    background-repeat: no-repeat;
    span{
      color: #fff;
      font-size: 12px;
      line-height: 19px;
      font-weight: 400;
      font-family: PingFang SC, PingFang SC;
      font-style: normal;
    }
  }

  .person_center_info{
    position: relative;
    padding: 5px 5px 0 5px;
    .info_wrapper{
      width: 180px;
      height: 145px;
      background: url(https://cdnws.51tyty.com/lstyty/file/2024/09/02/4ea1df271ac0dbfb8912f1b352fc6919.png);
      background-repeat: no-repeat;
      overflow: hidden;
      .info_top{
        display: flex;
        align-items: center;
        margin: 14.5px 13px 5.5px 11.5px;
        .l{
          width: 52.315px;
          height:52.315px;
          display: flex;
          align-items: center;
          justify-content: center;

          /deep/ .el-badge__content{
            background-color:#FF3B30!important;
          }

          img{
            border-radius: 50%;
            width: 39px;
            width: 39px;
          }
        }
        >span{
          font-size: 14px;
        }
      }

      .line{
        border-top:1px dashed #B0C4D6;
        margin: 0 16px;
      }

      .info_bottom{
        display: flex;
        justify-content: center;
        gap: 8px;
        padding: 0 18px;
        box-sizing: border-box;
        margin-top: 7px;
        .info_bottom_item{
          width: calc(85.33px / 2);
          height: calc(92px / 2);
          text-align: center;
          img{
            width:32px;
            height:32px;
          }
          p{
            color: #1D2129;
            font-size: 12px;
            text-align: center;
          }
        }
      }
    }
  }

  .person_center_func{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 7px 5px;
    padding: 3px 11.5px 12px 11.5px;
    box-sizing: border-box;
    .item{
      width: 81px;
      height: 47px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border-radius: 12px 12px 12px 12px;
      position: relative;
      img{
        width: 35px;
        height: 35px;
      }
      .label{
        font-size: 12px;
        color: #1D2129;
        padding: 0 3px;
      }
      .dot{
        width: 10px;
        height: 10px;
        background-color: #FF3B30;
        border-radius: 50% 50%;
        position: absolute;
        top: 0;
        right: 0;
      }
      .tag {
        position: absolute;
        top: -8px;
        left: -3px;
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
